import React from "react";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@mui/material/TextField";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Config from "conFig.js";
import { Error, Success } from "../../../assets/jss/util/messageUtil";

const Capnhatvipham = React.memo(function Capnhatvipham(props) {
  const { vipham_id } = props;
  const [loaivipham, setLoaivipham] = React.useState([]);
  const [loaiviphamvalue, setLoaiviphamvalue] = React.useState(null);
  const [coquanxuly, setCoquanxuly] = React.useState([]);
  const [coquanxulyvalue, setCoquanxulyvalue] = React.useState(null);
  const [tinhtrang, setTinhtrang] = React.useState([]);
  const [tinhtrangvalue, setTinhtrangvalue] = React.useState(null);
  const [bienkiemsoat, setBienkiemsoat] = React.useState("");
  const [ngayvipham, setNgayvipham] = React.useState(dayjs());
  const [motavipham, setMotavipham] = React.useState("");
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [alertValidate, setAlertValidate] = React.useState(false);
  const [messageValidate, setMessageValidate] = React.useState("");
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getloaivipham = () => {
    var url =
      Config.backend + "/api/Vipham/getdmloaivipham?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setLoaivipham(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getcoquanxuly = () => {
    var url =
      Config.backend +
      "/api/donvi/getdonvitheoloaidonvi?dmloaidonvi_id=11&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setCoquanxuly(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const gettinhtrang = () => {
    var url = Config.backend + "/api/ViPham/getdmttvipham?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setTinhtrang(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getviphamtheoid = () => {
    var url =
      Config.backend +
      "/api/ViPham/getviphamid?id=" +
      vipham_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setBienkiemsoat(data[0].bienkiemsoat);
        let [day, month, year] = data[0].ngayvipham.split("/");
        setNgayvipham(dayjs(year + "-" + month + "-" + day));
        setMotavipham(data[0].motavipham);
        setLoaiviphamvalue({
          id: data[0].loaivipham_id,
          ten: data[0].loaivipham,
        });
        setCoquanxulyvalue({
          id: data[0].coquanxulyvipham_id,
          ten: data[0].coquanxulyvipham,
        });
        setTinhtrangvalue({
          id: data[0].tinhtrangxulyvipham_id,
          ten: data[0].tinhtrangxuly,
        });
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const capnhatbaocao = () => {
    let mess = validateCapnhat();
    if (mess === Success.SC0001) {
      var ngayvp =
        ngayvipham.$y +
        "-" +
        String(ngayvipham.$M + 1).padStart(2, "0") +
        "-" +
        ngayvipham.$D;
      var url = Config.backend + "/api/ViPham/capnhatxulyvp";
      fetch(url, {
        method: "PUT",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          id: vipham_id,
          bienkiemsoat: bienkiemsoat,
          ngayvipham: ngayvp,
          loaivipham_id: loaiviphamvalue.id,
          motavipham: motavipham,
          tinhtrangxulyvipham_id: tinhtrangvalue.id,
          coquanxulyvipham_id: coquanxulyvalue.id,
          nhomvipham_id: 1,
          username: username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data === 1) {
            showNotification();
          } else showNotification1();
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  const validateCapnhat = () => {
    // Kiem tra cac truong bat buoc nhap
    if (!loaiviphamvalue || loaiviphamvalue === 0) {
      return Error.ER0018;
    }
    if (!coquanxulyvalue || coquanxulyvalue === 0) {
      return Error.ER0019;
    }
    if (!tinhtrangvalue || tinhtrangvalue == 0) {
      return Error.ER0020;
    }
    return Success.SC0001;
  };
  React.useEffect(() => {
    getloaivipham();
    getcoquanxuly();
    gettinhtrang();
    getviphamtheoid();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày vi phạm"
                  value={ngayvipham}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgayvipham(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Biển kiểm soát"
                variant="outlined"
                size="small"
                value={bienkiemsoat}
                onChange={(event) => {
                  setBienkiemsoat(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                value={loaiviphamvalue}
                getOptionSelected={(option, value) => option.id === value.id}
                options={loaivipham}
                getOptionLabel={(option) => option.ten || option.loaivipham}
                onChange={(event, value) => {
                  setLoaiviphamvalue(value);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setLoaiviphamvalue(null);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Loại vi phạm"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Mô tả vi phạm"
                variant="outlined"
                size="small"
                value={motavipham}
                onChange={(event) => {
                  setMotavipham(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                value={coquanxulyvalue}
                getOptionSelected={(option, value) => option.id === value.id}
                options={coquanxuly}
                getOptionLabel={(option) =>
                  option.ten || option.coquanxulyvipham
                }
                onChange={(event, value) => {
                  setCoquanxulyvalue(value);
                }}
                // onInputChange={(event, newInputValue, reason) => {
                //   if (reason !== "reset") {
                //     setCoquanxulyvalue(null);
                //   }
                // }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Cơ quan xử lý"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                value={tinhtrangvalue}
                getOptionSelected={(option, value) => option.id === value.id}
                options={tinhtrang}
                getOptionLabel={(option) => option.ten || option.tinhtrangxuly}
                onChange={(event, value) => {
                  setTinhtrangvalue(value);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setTinhtrangvalue(null);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Trạng thái xử lý"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "20px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          onClick={capnhatbaocao}
        >
          Cập nhật
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Cập nhật thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình cập nhật"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
});

Capnhatvipham.propTypes = {
  vipham_id: PropTypes.number,
};
export default Capnhatvipham;
